import { gsap } from 'gsap';
import { disposeSubAxis } from '../utils.mjs';

const relativeMouseBody = (ev, view, option) => {
  const data = relativeMouseBodySite(ev, view, option);
  if (option.initialization) {
    gsap.set(view, { x: data.offsetX, y: data.offsetY });
  }
  gsap.to(view, { duration: 0.2, x: data.offsetX, y: data.offsetY });
};
const relativeMouseBodyFixed = (ev, view, option) => {
  const data = relativeMouseBodyFixedSite(ev, view, option);
  if (option.initialization) {
    gsap.set(view, { x: data.offsetX, y: data.offsetY });
  }
  gsap.to(view, { duration: 0.2, x: data.offsetX, y: data.offsetY });
};
const relativeMouseBodySite = (ev, view, option) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const offsetXMin = ((_b = (_a = option.boundary) == null ? void 0 : _a.x) == null ? void 0 : _b.min) || 0;
  const offsetXMax = ((_d = (_c = option.boundary) == null ? void 0 : _c.x) == null ? void 0 : _d.max) || innerWidth;
  const offsetX = disposeSubAxis(
    { container: 0, space: option.offsetX, view: view.clientWidth },
    {
      min: offsetXMin + scrollX,
      max: offsetXMax + scrollX,
      align: ((_e = option.align) == null ? void 0 : _e.x) || "start",
      offset: ev.pageX,
      strategy: (_f = option.boundary) == null ? void 0 : _f.strategy
    }
  );
  const offsetYMin = ((_h = (_g = option.boundary) == null ? void 0 : _g.y) == null ? void 0 : _h.min) || 0;
  const offsetYMax = ((_j = (_i = option.boundary) == null ? void 0 : _i.y) == null ? void 0 : _j.max) || innerHeight;
  const offsetY = disposeSubAxis(
    { container: 0, space: option.offsetY, view: view.clientHeight },
    {
      min: offsetYMin + scrollY,
      max: offsetYMax + scrollY,
      align: ((_k = option.align) == null ? void 0 : _k.y) || "start",
      offset: ev.pageY,
      strategy: (_l = option.boundary) == null ? void 0 : _l.strategy
    }
  );
  return { offsetY: offsetY.offset, offsetX: offsetX.offset };
};
const relativeMouseBodyFixedSite = (ev, view, option) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const offsetXMin = ((_b = (_a = option.boundary) == null ? void 0 : _a.x) == null ? void 0 : _b.min) || 0;
  const offsetXMax = ((_d = (_c = option.boundary) == null ? void 0 : _c.x) == null ? void 0 : _d.max) || innerWidth;
  const offsetX = disposeSubAxis(
    { container: 0, space: option.offsetX, view: view.clientWidth },
    { min: offsetXMin, max: offsetXMax, align: ((_e = option.align) == null ? void 0 : _e.x) || "start", offset: ev.clientX, strategy: (_f = option.boundary) == null ? void 0 : _f.strategy }
  );
  const offsetYMin = ((_h = (_g = option.boundary) == null ? void 0 : _g.y) == null ? void 0 : _h.min) || 0;
  const offsetYMax = ((_j = (_i = option.boundary) == null ? void 0 : _i.y) == null ? void 0 : _j.max) || innerHeight;
  const offsetY = disposeSubAxis(
    { container: 0, space: option.offsetY, view: view.clientHeight },
    { min: offsetYMin, max: offsetYMax, align: ((_k = option.align) == null ? void 0 : _k.y) || "start", offset: ev.clientY, strategy: (_l = option.boundary) == null ? void 0 : _l.strategy }
  );
  return { offsetY: offsetY.offset, offsetX: offsetX.offset };
};

export { relativeMouseBody, relativeMouseBodyFixed, relativeMouseBodyFixedSite, relativeMouseBodySite };
//# sourceMappingURL=relativeMouseBody.mjs.map
